/* jshint esversion:9 */
import axios from 'axios';
import Storage from "./Storage";

export default class JwtClient {
    static getJwtHeader = () => {
        const token = Storage.getToken();
        return {
            headers: {
                Authorization: token ? `Bearer ${token}` : '',
            }
        };
    };

    static getDefaultOptions = () => {
        return {
            timeout: 60000,
        };
    };

    static get = (url, options = {}) => axios.get(url, {...this.getJwtHeader(), ...this.getDefaultOptions(), ...options});
    static post = (url, data, options = {}) => axios.post(url, data, {...this.getJwtHeader(), ...this.getDefaultOptions(), ...options});
    // static post = (url, data, options = {}) => Promise.resolve({status: 200});
    static put = (url, data, options = {}) => axios.put(url, data, {...this.getJwtHeader(), ...this.getDefaultOptions(), ...options});
    static delete = (url, options = {}) => axios.delete(url, {...this.getJwtHeader(), ...this.getDefaultOptions(), ...options});
}
